import React from 'react'

import ContentPage from './ContentPage.jsx'

import es from '../locales/privacyPolicy_es.json'
import en from '../locales/privacyPolicy_en.json'

function PrivacyPolicy() {
  return <ContentPage es={es} en={en} />
}

export default PrivacyPolicy